import React from "react";

interface State {
  error: Error | null;
}

export class ErrorBoundary extends React.Component<
  { children: React.ReactNode },
  State
> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error("Uncaught error in dashboard:", error, info);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="m-lg rounded-md border border-danger-bg bg-danger-bg p-md text-danger-text">
          <h2 className="font-semibold mb-sm">Something went wrong.</h2>
          <pre className="whitespace-pre-wrap text-xs">{this.state.error.message}</pre>
        </div>
      );
    }
    return this.props.children;
  }
}
